// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoChatWindow_wrapper__2_Aca","app-bar":"VideoChatWindow_app-bar__qa4Fj"};